export const generateLog = (type, tag, msg, ...optionalParams) => {
    switch (type) {
        case 'default':
            console.log(tag + ": " + msg, optionalParams);
            break;
        case 'error':
            console.error(tag + ": " + msg, optionalParams);
            break;
        case 'warning':
            console.warn(tag + ": " + msg, optionalParams);
            break;
        default:
            console.log(tag + ": " + msg, optionalParams);
            break;
    }
}